import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalTask {
  id: number;
  title: string;
  description: string;
  due_date: string; // YYYY-MM-DD
  is_urgent: boolean;
  is_important: boolean;
  status: 'pending' | 'completed';
  transaction_id?: number;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
  created_at: string;
  updated_at?: string;
}

export function listTasks(): Promise<LocalTask[]> {
  return dbGetAll<LocalTask>('tasks');
}

export function getTaskById(id: number) {
  return dbGetById<LocalTask>('tasks', id);
}

export async function createTask(data: Omit<LocalTask, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>) {
  const now = new Date().toISOString();
  return dbAdd('tasks', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateTask(id: number, data: Partial<LocalTask>) {
  const current = await dbGetById<LocalTask>('tasks', id);
  if (!current) throw new Error('Task not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true
  };
  await dbPut('tasks', updated);
  return updated;
}

export async function removeTask(id: number) {
  return dbDelete('tasks', id);
}

export async function getTasksNeedingSync(): Promise<LocalTask[]> {
  const all = await dbGetAll<LocalTask>('tasks');
  return all.filter(t => t.needs_sync === true);
}

export async function markSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalTask>('tasks', id);
  if (!current) throw new Error('Task not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('tasks', current);
  return current;
}

